import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type ScheduledRoutesByIdInput,
  scheduledRoutesByIdInputSchema,
} from "./shared/scheduledRoutes.input";
import {
  type SchedRoute,
  schedRouteSchema,
} from "./shared/scheduledRoutes.output";

/**
 * Metadata for the fetchScheduledRoutesById endpoint
 */
export const scheduledRoutesByIdMeta = {
  functionName: "fetchScheduledRoutesById",
  endpoint: "/schedroutes/{ScheduleID}",
  inputSchema: scheduledRoutesByIdInputSchema,
  outputSchema: schedRouteSchema.array(),
  sampleParams: { ScheduleID: 193 },
  endpointDescription: "List scheduled routes for a specific schedule season.",
} satisfies EndpointMeta<ScheduledRoutesByIdInput, SchedRoute[]>;

/**
 * Fetch function for retrieving scheduled routes for a specific schedule season
 */
const { fetch, useHook } = createFetchAndHook<
  ScheduledRoutesByIdInput,
  SchedRoute[]
>({
  api: wsfScheduleApiMeta,
  endpoint: scheduledRoutesByIdMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/scheduledRoutes.endpoints").scheduledRoutesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving scheduled routes for a specific schedule season
 */
export const fetchScheduledRoutesById: FetchFactory<
  ScheduledRoutesByIdInput,
  SchedRoute[]
> = fetch;

/**
 * React Query hook for retrieving scheduled routes for a specific schedule season
 */
export const useScheduledRoutesById: HookFactory<
  ScheduledRoutesByIdInput,
  SchedRoute[]
> = useHook;
